import { render } from "./AssignToStudent.vue?vue&type=template&id=78df1310&scoped=true"
import script from "./AssignToStudent.vue?vue&type=script&lang=js"
export * from "./AssignToStudent.vue?vue&type=script&lang=js"

import "./AssignToStudent.vue?vue&type=style&index=0&id=78df1310&scoped=true&lang=css"

import exportComponent from "/voc/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-78df1310"]])

export default __exports__